<div class="frame-generator-container">
  <div class="header-section">
    <div class="title-section">
      <i class="bi bi-camera-video title-icon"></i>
      <div class="title">{{ videoData.name }}</div>
    </div>

    <div class="file-info">
      <span class="file-size">
        {{ formatFileSize(videoData.size) }}
      </span>
    </div>
  </div>

  <div class="video-section">
    <div class="video-container">
      <video
        #videoPlayer
        class="video-player"
        preload="metadata"
        [src]="videoData.url"
        (timeupdate)="onTimeUpdate()"
        (loadedmetadata)="onTimeUpdate()"
        (ended)="onVideoEnded()">
      </video>

      <div
        class="play-overlay"
        *ngIf="!isPlaying"
        (click)="onPlayPause()">
        <div class="play-button">
          <i class="bi bi-play-fill"></i>
        </div>
      </div>
    </div>

    <div class="video-controls">
      <button
        class="play-pause-btn"
        (click)="onPlayPause()">
        <i
          class="bi"
          [class.bi-play-fill]="!isPlaying"
          [class.bi-pause-fill]="isPlaying">
        </i>
      </button>

      <div class="progress-container">
        <input
          class="progress-slider"
          type="range"
          min="0"
          max="100"
          step="0.1"
          [value]="progress"
          (input)="onSeek($event)">
      </div>

      <div class="time-display">
        <span class="current-time">
          {{ formatTime(currentTime) }}
        </span>
        <span class="separator">/</span>
        <span class="total-time">
          {{ formatTime(duration) }}
        </span>
      </div>

      <div class="volume-control">
        <i
          class="bi volume-icon"
          [class.bi-volume-mute]="isMuted || volume === 0"
          [class.bi-volume-up]="!isMuted && volume > 0"
          (click)="onVolumeMute()">
        </i>
        <input
          class="volume-slider"
          type="range"
          min="0"
          max="100"
          step="1"
          [value]="volume"
          (input)="onVolumeChange($event)">
      </div>

      <button
        class="fullscreen-btn"
        (click)="onFullscreenToggle()">
        <i
          class="bi"
          [class.bi-arrows-fullscreen]="!isFullscreen"
          [class.bi-fullscreen-exit]="isFullscreen">
        </i>
      </button>
    </div>
  </div>

  <div class="scan-settings-section">
    <div class="settings-controls">
      <div class="setting-item">
        <div class="setting-label">
          <i class="bi bi-stopwatch setting-icon"></i>
          <span class="setting-name">Interval</span>
        </div>

        <div class="settings-slider-container">
          <input
            class="settings-slider"
            type="range"
            min="0.1"
            max="2.0"
            step="0.1"
            [value]="interval"
            (input)="onIntervalChange($event)">
          <span class="setting-value">
            {{ interval }}s
          </span>
        </div>
      </div>

      <div class="setting-item">
        <div class="setting-label">
          <i class="bi bi-bullseye setting-icon"></i>
          <span class="setting-name">Confidence</span>
        </div>

        <div class="settings-slider-container">
          <input
            class="settings-slider"
            type="range"
            min="10"
            max="100"
            step="5"
            [value]="confidence"
            (input)="onConfidenceChange($event)">
          <span class="setting-value">
            {{ confidence }}%
          </span>
        </div>
      </div>
    </div>
  </div>

  <div class="action-section">
    <button
      class="change-video-btn"
      (click)="onChangeVideoClicked()"
    >
      <i class="bi bi-upload change-icon"></i>
      <span>Change Video</span>
    </button>

    <div
      class="scan-status"
      *ngIf="isScanning">
      <span class="status-text">
        Scanning Faces:
        {{ extractionProgress.currentFrame }}/{{ extractionProgress.totalFrames }}
        ({{ extractionProgress.progress | number: '1.0-0' }}%)
      </span>

      <div class="progress-bar-container">
        <div
          class="progress-bar"
          [style.width.%]="extractionProgress.progress">
        </div>
      </div>
    </div>

    <div
      class="scan-status"
      *ngIf="isScrapping">
      <span class="status-text">
        Scrapping Faces:
        {{ scrapProgress.currentFrame }}/{{ scrapProgress.totalFrames }}
        ({{ scrapProgress.progress | number: '1.0-0' }}%)
      </span>

      <div class="progress-bar-container">
        <div
          class="progress-bar"
          [style.width.%]="scrapProgress.progress">
        </div>
      </div>
    </div>

    <button
      class="start-scan-btn"
      *ngIf="!isScanning && !isScrapping"
      (click)="startScanning()">
      <i class="bi bi-play-circle scan-icon"></i>
      <span>Start Scan</span>
    </button>
  </div>
</div>
